import React, { useState } from "react";
import { Card, CardBody, Col, Container, Row, Button } from "reactstrap";
import { DashboardPageHeader } from "../../Components/Common/DashboardKit";
import AllDocuments from "./AllDocuments";
import { PaginationExample } from "../Tables/GridTables/GridTablesData";

const Data = () => {
  document.title = "Document Management System - SSW Technologies Dashboard";
  const [gotoPage, setGotoPage] = useState("");

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <DashboardPageHeader
            icon="ri-file-list-3-line"
            eyebrow="Documents"
            title="All Documents"
            subtitle="Searchable catalog of company documents across all types."
            tone="blue"
            breadcrumb={[
              { label: "Dashboards", to: "/" },
              { label: "DMS" },
            ]}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div id="table-pagination">
                    <AllDocuments>
                      {({
                        gridData,
                        loading,
                        page,
                        totalPages,
                        setPage,
                        pageSize,
                        setPageSize,
                        docType,
                        setDocType,
                        show,
                        setShow,
                        search,
                        setSearch,
                        author,
                        setAuthor,
                        DOC_TYPES,
                        SHOW_OPTIONS,
                        PAGE_SIZE_OPTIONS,
                        handleSearchSubmit,
                        totalCount,
                      }) => (
                        <>
                          {/* Top Row: Beautified DocType, Show, PageSize, Results */}
                          <div className="d-flex justify-content-between align-items-center flex-wrap mb-2" style={{ minHeight: 38 }}>
                            {/* Left: BEAUTIFIED DocType and Show */}
                            <div className="d-flex align-items-center flex-wrap gap-4">
                              {/* Doc Type Group */}
                              <div className="d-flex align-items-center gap-2">
                                <span className="fw-semibold text-dark">Doc Type:</span>
                                {DOC_TYPES.map(type => (
                                  <div className="form-check form-check-inline mb-0" key={type}>
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="docType"
                                      id={`docType-${type}`}
                                      value={type}
                                      checked={docType === type}
                                      onChange={() => {
                                        setDocType(type);
                                        setPage(1);
                                      }}
                                    />
                                    <label className="form-check-label" htmlFor={`docType-${type}`}>
                                      {type}
                                    </label>
                                  </div>
                                ))}
                              </div>
                              {/* Show Group */}
                              <div className="d-flex align-items-center gap-2">
                                <span className="fw-semibold text-dark">Show:</span>
                                {SHOW_OPTIONS.map(option => (
                                  <div className="form-check form-check-inline mb-0" key={option}>
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="showOption"
                                      id={`showOption-${option}`}
                                      value={option}
                                      checked={show === option}
                                      onChange={() => {
                                        setShow(option);
                                        setPage(1);
                                      }}
                                    />
                                    <label className="form-check-label" htmlFor={`showOption-${option}`}>
                                      {option}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </div>
                            {/* Right: PageSize and Results */}
                            <div className="d-flex align-items-center">
                              <label className="me-2 mb-0 fw-semibold">Page size:</label>
                              <select
                                className="form-select form-select-sm"
                                style={{ width: 100 }}
                                value={pageSize}
                                onChange={(e) => {
                                  setPageSize(Number(e.target.value));
                                  setPage(1);
                                }}
                              >
                                {PAGE_SIZE_OPTIONS.map((sz) => (
                                  <option key={sz} value={sz}>
                                    {sz}
                                  </option>
                                ))}
                              </select>
                              <span className="ms-3 text-muted" style={{ whiteSpace: "nowrap" }} >
                                {loading
                                  ? "Loading..."
                                  : `Showing page ${page} of ${totalPages} (${totalCount} results)`}
                              </span>
                            </div>
                          </div>

                          {/* Search/filter form BELOW the controls */}
                          <form className="mb-3" onSubmit={handleSearchSubmit}>
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                              <input
                                className="form-control"
                                type="text"
                                placeholder="Search DocID, Title, Author"
                                value={search}
                                onChange={(e) => {
                                  setSearch(e.target.value);
                                  setPage(1);
                                }}
                                style={{ minWidth: 200 }}
                              />
                              {show === "MyDocs" }
                            </div>
                          </form>

                          {/* Data Table */}
                          <PaginationExample
                            data={gridData}
                            loading={loading}
                          />

                          {/* Pagination controls */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              gap: 10,
                              marginTop: 10,
                            }}
                          >
                            {/* Left side: Prev/Page/Next */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                              }}
                            >
                              <div className="d-flex flex-wrap gap-2">
                                <Button
                                  color="primary"
                                  type="button"
                                  disabled={page <= 1}
                                  onClick={() => setPage(page - 1)}
                                >
                                  Prev
                                </Button>
                              </div>
                              <span className="text-muted">
                                Page {page} of {totalPages}
                              </span>
                              <div className="d-flex flex-wrap gap-2">
                                <Button
                                  color="primary"
                                  type="button"
                                  disabled={page >= totalPages}
                                  onClick={() => setPage(page + 1)}
                                >
                                  Next
                                </Button>
                              </div>
                            </div>
                            {/* Right side: Go to page */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                                marginRight: 48,
                              }}
                            >
                              <input
                                className="form-control"
                                type="number"
                                min={1}
                                max={totalPages}
                                value={gotoPage}
                                onChange={(e) => {
                                  setGotoPage(e.target.value);
                                  console.log(
                                    "gotoPage changed to",
                                    e.target.value
                                  );
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    const num = Number(gotoPage);
                                    if (num >= 1 && num <= totalPages) {
                                      setPage(num);
                                      setGotoPage("");
                                    }
                                  }
                                }}
                                placeholder="Go to page"
                                style={{ width: 100 }}
                              />
                              <div className="d-flex flex-wrap gap-2">
                                <Button
                                  color="primary"
                                  type="button"
                                  onClick={() => {
                                    const num = Number(gotoPage);
                                    if (num >= 1 && num <= totalPages) {
                                      setPage(num);
                                      setGotoPage("");
                                    }
                                  }}
                                  disabled={
                                    !gotoPage ||
                                    Number(gotoPage) < 1 ||
                                    Number(gotoPage) > totalPages
                                  }
                                >
                                  Go
                                </Button>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </AllDocuments>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Data;
